import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MapsAPILoader } from "@agm/core";

import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";

import { CUSTOM_MAP_STYLE } from "../../../util/map-style";
import { ProjectItem } from "../../../models/project-item.model";

@Component({
  selector: "app-projects-map",
  templateUrl: "./projects-map.component.html",
  styleUrls: ["./projects-map.component.scss"],
})
export class ProjectsMapComponent implements OnInit {
  @ViewChild("search")
  public searchElementRef: ElementRef;

  @Input() disableScroll: boolean;
  @Input() focusOn: string;
  projects: ProjectItem[] = [];

  zoom = 11;
  mapCenterLatitude = 47.74435555802254;
  mapCenterLongitude = 18.107167170399833;
  bounds: any;
  map: any;
  customGoogleMapStyle: any;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private translate: TranslateService,
    private router: Router
  ) {
    this.customGoogleMapStyle = CUSTOM_MAP_STYLE;
  }

  ngOnInit() {
    const projectItem1 = new ProjectItem();
    projectItem1.name = "Gesztenye Liget";
    projectItem1.latitude = 47.74435555802254;
    projectItem1.longitude = 18.107167170399833;
    projectItem1.code = "GESZTENYE_LIGET";
    this.projects.push(projectItem1);

    this.mapCenterLatitude = this.projects[0].latitude;
    this.mapCenterLongitude = this.projects[0].longitude;
    this.zoom = 15;
  }

  onMapReady(map) {
    this.map = map;
    this.map.styles = this.customGoogleMapStyle;
    this.setBounds();
  }

  setBounds() {}

  openProjectPage(project: ProjectItem) {
    this.router.navigateByUrl("/project/" + project.code);
  }
}
